import * as React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";

const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({
    className,
    ...props
}, ref) => (
    <div
        ref={ref}
        className={generateValidClassNameHandler(
            "relative flex flex-col rounded bg-card border border-gray-300 p-3 shadow-custom md:p-6 justify-center",
            className,
        )}
        {...props}
    />
));
Card.displayName = "Card";

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({
    className,
    ...props
}, ref) => (
    <div
        ref={ref}
        className={generateValidClassNameHandler(
            "flex flex-row items-center justify-between mb-2 md:mb-4",
            className,
        )}
        {...props}
    />
));
CardHeader.displayName = "CardHeader";

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({
    className,
    ...props
}, ref) => (
    <h3 // eslint-disable-line
        ref={ref}
        className={generateValidClassNameHandler(
            "w-full text-sm text-foreground lg:text-lg tracking-tight",
            className,
        )}
        {...props}
    />
));
CardTitle.displayName = "CardTitle";

const CardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({
    className,
    ...props
}, ref) => (
    <p
        ref={ref}
        className={generateValidClassNameHandler(
            "text-xs md:text-sm text-gray-500",
            className,
        )}
        {...props}
    />
));
CardDescription.displayName = "CardDescription";

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({
    className,
    ...props
}, ref) => (
    <div
        className={generateValidClassNameHandler(className)}
        ref={ref}
        {...props}
    />
));
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({
    className,
    ...props
}, ref) => (
    <div
        ref={ref}
        className={generateValidClassNameHandler(
            "flex items-center p-6 pt-0",
            className,
        )}
        {...props}
    />
));

CardFooter.displayName = "CardFooter";

export {
    Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle,
};
